.wrapper {
	position: relative;
}

.currency {
	position: absolute;
	top: 29px;
	right: 12px;
	line-height: 1.5;
	color: var(--content-tertiary);
	text-transform: uppercase;
	composes: body-2 bold from global;
	pointer-events: none;
	user-select: none;
}

.amount input {
	/* Space for currency */
	padding: 8px 48px 8px 12px;
}

/* Hide react-aria increment/decrement stepper buttons */
.amount [slot="increment"],
.amount [slot="decrement"] {
	display: none;
}

/* Hide browser native spinners */
.amount input::-webkit-inner-spin-button,
.amount input::-webkit-outer-spin-button {
	display: none;
}
